/**
 * Create URL query from object.
 * Replace false value with ""
 * @param {*} obj 
 * @returns 
 */
export const buildURLQuery = function (obj) {
  return Object.entries(obj)
    .map(pair => pair.map(encodeURIComponent).join("="))
    .join("&")
  .replaceAll("undefined", "")
  .replaceAll("false", "");
}

/**
 * Convert search query to object
 */
export const queryParser = function (queryStr) {
  let query = queryStr.substring(1)
  let vars = query.split("&")
  let queryObj = {}
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=")
    queryObj[pair[0]] = pair[1]
  }
  return queryObj
}

/**
 * Compare query strings by param values, ignoring key order.
 * Prevents soft redirects from replaceState when only serialization differs.
 */
export const areSearchParamsEqual = function (a = "", b = "") {
  const normalize = value => {
    const raw = String(value || "")
    return raw.startsWith("?") ? raw.slice(1) : raw
  }

  const left = new URLSearchParams(normalize(a))
  const right = new URLSearchParams(normalize(b))
  const keys = new Set([...left.keys(), ...right.keys()])

  for (const key of keys) {
    if ((left.get(key) ?? "") !== (right.get(key) ?? "")) {
      return false
    }
  }

  return true
}



export const scrollToTop = () => {
  if (typeof window != "undefined") {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }
}